import { apiLink } from './../../../constant/api-link';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { CategoriesQoIndexModel,
  GetQuotationItemModel,
  QuotaionItemlistModelIndexModel
} from "../../../model/jubili/quotationitem/quotation";

@Injectable({
  providedIn: "root"
})
export class QuotationItemService {

    constructor(
        private http: HttpClient
    ) { }

    // get quotationitem (sort,search,filter)
    getAllQuotationItemBackOffice(getquotation: GetQuotationItemModel): Observable<QuotaionItemlistModelIndexModel> {
        const url = apiLink.getQoItemList;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.post<QuotaionItemlistModelIndexModel>(url, getquotation, { headers });
    }

    // get categories quotation
  getCategoriesBackOffice(page: number, pageSize: number, search: string | null): Observable<CategoriesQoIndexModel> {
      const url = apiLink.getCategoriesList;
      let params = new HttpParams()
        .set("page", page.toString())
        .set("pageSize", pageSize.toString());

    if (search && search.trim()) {
      params = params.set("search", search);
    }

      return this.http.get<CategoriesQoIndexModel>(url, { params: params });
    }
}
